export default "__VITE_ASSET__BJ41V4Nj__"